import React from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import TherapyServicesContent from '../components/TherapyServicesContent';
import Footer from '../components/Footer';

const TherapyServices = () => {
  return (
    <div className="TherapyServices">
      <Header />
      <div className="mt-32 sm:mt-36 lg:mt-32">
        <Hero image="/assets/images/therapy-services-hero.jpg" heightClass="min-h-[50vh] sm:min-h-[60vh] lg:min-h-[70vh]" />
        <TherapyServicesContent />
        <Footer />
      </div>
    </div>
  );
};

export default TherapyServices;


